import styled from "styled-components";
import { analysisPeriodDescription } from "./analysisPeriodLabel";
import { useTranslation } from "react-i18next";
import { getAppLanguage } from "src/i18n";

const Caption = styled.span`
	display: flex; flex-direction: column; gap: 2px; min-width: 0; font-size: 11px; line-height: 1.5;
	strong { color: #475467; font-size: 12px; font-weight: 500; }
	> span { color: #667085; white-space: nowrap; }
`;

export const AnalysisPeriodCaption = ({ from, to, currency }: { from: string; to: string; currency: string }) => {
	const { t } = useTranslation();
	const { label, exact } = analysisPeriodDescription(from, to, new Date(), getAppLanguage());
	return <Caption>
		{label && <strong>{label}</strong>}
		<span>{currency || t("bankAnalysis.allCurrencies")} · {exact}</span>
	</Caption>;
};
